import { connect } from 'react-redux'

import AppModesSwitcher from '../components/AppModesSwitcher'
import * as actions from '../actions'
import { RootState, AppMode, AppTheme } from '../types'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { setAppMode, setAppTheme } from '../actions/commonActions'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const { appState } = rootState
  return {
    appType: appState.appType,
    appMode: appState.appMode,
    appTheme: appState.appTheme,
    tradesCount: mt4.positions.size,
    ordersCount: mt4.pendingOrders.size,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<actions.TradingAction>) {
  return {
    onSetAppMode: (mode: AppMode) => dispatch(setAppMode(mode)),
    onSetAppTheme: (theme: AppTheme) => dispatch(setAppTheme(theme)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppModesSwitcher)
